define([
	"dojo/_base/declare",
	"csi",
	"csi/core/ExtendedPath",
	"csi/core/Key",
	"csi/heading/_base",
	"csi/heading/Renderer",
	"csi/xml",
	"./SourceObjectRevisionRenderer"
], function(declare, csi, ExtendedPath, Key, csiHeading, Renderer, xml, SourceObjectRevisionRenderer) {

	return declare(Renderer, {
		headingToHtml: function(/*Context*/ctx, /*Heading*/h, /*DOMNode*/refNode) {
			var cDoc = ctx.getNodeParent();
			var source = xml.enumGetText(cDoc.SourceType);
			if (!source) {
				refNode.innerHTML = csi.EMPTY_CHAR;
				return; // bad doc
			}

			var id;

			if (source == "Web") {
				id = "SourceWebURL";
			} else if (source == "File") {
				id = "SourceFile";
			} else if (source == "Object") {
				id = "SourceObjectRevision";
			}

			const sourceHeading = ctx.view.getHeading(new Key({
				extendedPath: ExtendedPath.create(ctx.defView.getPageClass(), h.m_path),
				id,
			}));

			sourceHeading.m_right = h.m_right;

			// apply rule from SiteAdmin/RevisionHeadingsController to appropriate source heading
			ctx.view.addCurrentRevisionRule?.(sourceHeading);

			csiHeading.getHeadingRenderer(ctx, sourceHeading).headingToHtml(ctx, sourceHeading, refNode);
		}
	});
});